import { useTranslation } from "react-i18next"

interface Props {
  axisColor?: string
  axisName: string
  axesCount: number
  axesCountDone: number
  currentAxis?: string | null
  isLightBackground?: boolean
  questionIndex: number
  questionsCount: number
}

export default function QuestionProgress(props: Props) {
  const { t } = useTranslation()

  return (
    <div className={"questions-progress flex" + (props.isLightBackground ? " questions-progress-light" : "")}>
      <div className="flex1 questions-progress-label">
        {props.axesCount > 1 && props.currentAxis ? (
          <span>{`${t("topic")} ${props.axesCountDone} / ${props.axesCount} : ${props.axisName}`}</span>
        ) : (
          <span>{t("topic_empty")}</span>
        )}
      </div>

      <div className="flex4 flex flex-dcol questions-progress-bar-wrapper">
        <div className="flex1" />
        <div className="questions-progress-bar">
          <div
            className="questions-progress-bar-value"
            style={{
              backgroundColor: props.axisColor ? props.axisColor + "80" : "#8c8c8ccc",
              width: `${(props.questionIndex / props.questionsCount) * 100}%`
            }}
          />
        </div>
        <div className="flex1" />
      </div>

      <div className="flex1 questions-progress-label questions-progress-question">
        <span>{`${t("question")} ${props.questionIndex + 1} / ${props.questionsCount}`}</span>
      </div>
    </div>
  )
}
